const SIGN_ALIASES = Object.freeze({
  aries: 'aries', tauro: 'tauro', taurus: 'tauro', geminis: 'geminis', gemini: 'geminis',
  cancer: 'cancer', leo: 'leo', virgo: 'virgo', libra: 'libra', escorpio: 'escorpio',
  scorpio: 'escorpio', sagitario: 'sagitario', sagittarius: 'sagitario',
  capricornio: 'capricornio', capricorn: 'capricornio', acuario: 'acuario', aquarius: 'acuario',
  piscis: 'piscis', pisces: 'piscis',
});

export function canonicalZodiacRoomId(value) {
  const match = String(value || '').trim().toLowerCase().match(/^(?:room|sign):([a-záéíóúüñ]+)$/);
  if (!match) return '';
  const signKey = match[1].normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const sign = SIGN_ALIASES[signKey];
  return sign ? `room:${sign}` : '';
}

export function normalizeRoomParticipantId(participant) {
  const candidate = participant?.userId ?? participant?._id ?? participant?.id ?? participant?.participantId;
  const id = String(candidate || '').trim().replace(/-DEVLOCAL$/i, '');
  return id && id !== 'null' && id !== 'undefined' ? id : '';
}

export function mergeRoomSnapshot(previous, incoming, latestSnapshotAt = 0) {
  const snapshotAt = Number(incoming?.snapshotAt || 0);
  if (latestSnapshotAt && snapshotAt && snapshotAt < latestSnapshotAt) {
    return { users: previous, snapshotAt: latestSnapshotAt, applied: false };
  }
  const byUser = new Map();
  for (const participant of Array.isArray(incoming?.users) ? incoming.users : []) {
    const userId = normalizeRoomParticipantId(participant);
    const key = userId ? `user:${userId}` : `guest:${String(participant?.fullName || '').trim().toLowerCase()}`;
    if (key !== 'guest:') byUser.set(key, { ...participant, ...(userId ? { id: userId, userId } : {}) });
  }
  return { users: [...byUser.values()], snapshotAt: Math.max(latestSnapshotAt, snapshotAt), applied: true };
}
